import { useWebshop } from 'hooks/useWebshop';
import Quantity, { QuantityProps } from 'components/Quantity';

/**
 * Wraps the Quantity component and only renders it if the webshop is enabled. (i.e. if user is not a consultant).
 */
export default function PublicQuantity(props: QuantityProps) {
    const { isPurchaseDisabled } = useWebshop();
    if (isPurchaseDisabled) {
        return null;
    }

    return <Quantity {...props} />;
}
